var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoQueenBedNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_18651",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 18651",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1822",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 1822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_17349",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 17349",
    d: "M12.713,6.224V9.539H6.5V6.217a10.543,10.543,0,0,1,3.057-.464,11.088,11.088,0,0,1,3.162.471m4.573,3.315V6.217a10.543,10.543,0,0,1,3.057-.464,11.11,11.11,0,0,1,3.162.471V9.539ZM1.7,11.342H28.3v8.545H1.7ZM14.838,0A36.95,36.95,0,0,0,1.907,2.423V9.539H0V24H1.7l.3-2.311H28L28.3,24H30V9.539H28.093V2.414A39.1,39.1,0,0,0,14.837,0Zm-.419,4.906a13.936,13.936,0,0,0-4.867-.949,13.168,13.168,0,0,0-4.761.957V9.539H3.612V3.713A34.507,34.507,0,0,1,14.838,1.8,36.442,36.442,0,0,1,26.389,3.721V9.539h-1.18V4.906l-.589-.2a12.915,12.915,0,0,0-4.278-.744,13.168,13.168,0,0,0-4.761.957V9.538H14.418Z",
    transform: "translate(0 0)",
    fill: "#1d1d1f",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoQueenBedNew);
export default __webpack_public_path__ + "static/media/icoQueenBedNew.3deee70f45fd5423934639b55f3dee33.svg";
export { ForwardRef as ReactComponent };